import { memo, useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCreateSubject } from "../../../../hooks/query/useCreateSubject";
import { useGetAllSubject } from "../../../../hooks/query/useGetAllSubject";
import InputText from "../../../InputText";
import WarningDeleteSubjectPopup from "../../../WarningDeleteSubjectPopup";
import SubjectTag from "../../SubjectTag";

function Subject() {
    const [name, setName] = useState("");
    const [show, setShow] = useState<boolean>(false);
    const [subjectId, setSubjectId] = useState<number | null>(null);
    const { data, isLoading } = useGetAllSubject();
    const { mutate: createSubject } = useCreateSubject();
    console.log("data", data);
    const handleCreateSubject = useCallback(() => {
        createSubject(
            { name },
            {
                onSuccess: () => {
                    setName("");
                    toast.success("Tạo môn học thành công!");
                },
            }
        );
    }, [name, createSubject]);

    const handleDeleteSubject = (courseId: number) => {
        setShow(true);
        setSubjectId(courseId);
    }

    const handleCloseDeletePopup = () => {
        setShow(false);
        setSubjectId(null);
    };

    return (
        <div className="mt-[20px] w-full h-full">
            {show && (<WarningDeleteSubjectPopup
                subjectId={subjectId}
                onClose={handleCloseDeletePopup}
                onCancel={handleCloseDeletePopup}
                onSuccess={() => {
                    toast.success("Xóa file thành công!");
                }}
            />)}
            <div>
                <h1 className="font-bold text-[20px] text-center">Tạo mới môn học</h1>
                <div className="w-[30%] mt-[20px]">
                    <InputText value={name} onChange={(e) => setName(e.target.value)} label="Tên môn học" placeholder="Nhập tên môn học..." name="name" inputStyle="text-black" />
                    <button onClick={handleCreateSubject} className="mt-[15px] bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Tạo môn học</button>
                </div>
                <div>
                    <hr className="my-6" />
                    <h2 className="font-bold text-[20px] my-[10px] text-center">Danh sách môn học</h2>
                    {isLoading && <p>Loading...</p>}
                    <div className="space-y-2">
                        {data?.data
                            ?.slice()
                            .sort((a: any, b: any) => a.id - b.id)
                            .map((subject: any) => (
                                <SubjectTag
                                    key={subject.id}
                                    subject={subject}
                                    onEdit={(id: number) => { }}
                                    onDelete={(id: number) => {
                                        handleDeleteSubject(id);
                                    }}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(Subject);